import React from 'react';
import { Grid, Paper } from '@mui/material';
import { CraftList } from 'views/Aerospace/CraftList';

export const Overlay = props => {
  return (
    <Grid container className="z-10 absolute p-4 pointer-events-none">
      <Paper className="rounded-2xl pointer-events-auto">
        <Grid item xs>
          <CraftList />
        </Grid>
      </Paper>
    </Grid>
  );
};
